import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import { CookieService } from 'ngx-cookie-service';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
  selector: 'app-group-survey-list',
  templateUrl: './group-survey-list.component.html',
  styleUrls: ['./group-survey-list.component.css']
})
export class GroupSurveyListComponent implements OnInit {
  surveyForm: any;
  surveyList: any;
  pager: any = {};
  pagedItems: any[];
  total: any;
  limit: any;
  pageNo: any;
  base64textString: any;
  attached_image: any;
  flashMsg: string;
  selectedSurveyData: any;
  selectedSurveyId: any;
  surveyTypeList: any;
  surveyExpiryList: any;
  surveyCategoryList: any;
  url: any;
  surveyType: any;
  isDeleteSurvey: boolean;
  deleteSelectedSurveyData: any;
  searchStr: any = "";
  surveyCategory: any = "";
  surveyStatus: any = "";
  isSurveyAvailable: boolean = false;
  redirectUrl: any;
  redirectUrlGroup:any;
  activePageNo: number = 0;
  my_group_list = [];
  selected_group_id = null;
  constructor(private commonService: CommonService, private authService: AuthService,
    private router: Router, private validationService: ValidationService,
    private pagerService: PagerService, private cookieService: CookieService) { }

  ngOnInit() {
    this.initialiseSurvey();
    this.commonService.process();
  }

  // Get Survey List
  initialiseSurvey = function () {
		$('.navbar-brand').text('Group Surveys');
    this.commonService.setTitle();
    this.limit = 10;
    this.pageNo = 1;
    this.url = '';
    this.surveyStatus = 0;

    // Get survey expiry date
    this.authService.getSurveyExpiryList().subscribe(data => {
      if (data.success) {
        this.surveyExpiryList = data.time;
      }
    });

    let route = this.router.url;
    if (route.indexOf("?") !== -1) {

      var routeArr = route.split('?backUrl=');
      var decodedUri = decodeURIComponent(routeArr[1]);
      var decodedArr = decodedUri.split("&");
      var decodedPageNo = decodedArr[0].split("pageNo=");
      this.pageNo = decodedPageNo[1];
      this.activePageNo = decodedPageNo[1];

      var decodedSurveyCategory = decodedArr[1].split("categoryId=");
      this.surveyCategory = decodedSurveyCategory[1];

      var decodedSurveyStatus = decodedArr[2].split("surveyStatus=");
      this.surveyStatus = decodedSurveyStatus[1];

      var decodedSearchStr = decodedArr[3].split("searchStr=");
      this.searchStr = decodedSearchStr[1];

      var decodedUrl = decodedArr[4].split("surveyTypeId=");
      this.url =(decodedUrl[1] == "123456" ? '' : decodedUrl[1]);

      this.surveyStatus = (this.surveyStatus == undefined || this.searchStr == '') ? null : this.surveyStatus;
    }

    // Get survey category list
    this.authService.getSurveyCategoryList().subscribe(data => {
      if (data.success) {
        var that = this;
        this.surveyCategoryList = data.category;
        setTimeout(function () {
          $("#surveyCategory").val(that.surveyCategory);
          $("#surveyStatus").val(that.surveyStatus);
          $("#search").val(that.searchStr);
          $('#page_' + that.activePageNo).addClass('active');
          if (that.activePageNo == 1)
            $('#first, #prev').addClass('disabled');
          else if (that.activePageNo == that.pager.totalPages)
            $('#next, #last').addClass('disabled');
        }, 300);
      }
    });

    //get Group List
    this.authService.getAllGroupsList().subscribe(data => {
      if (data.success) {
          this.my_group_list = data.groups;
      }
    });

    // Get survey list
    this.getGroupSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);

    this.surveyForm = new FormGroup({
      question: new FormControl("", Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.minLength(10),
      ])),

      option_1: new FormControl("", Validators.compose([
        Validators.required,
        Validators.maxLength(50)
      ])),

      option_2: new FormControl("", Validators.compose([
        Validators.required,
        Validators.maxLength(50)
      ])),

      option_3: new FormControl("", Validators.maxLength(50)),

      option_4: new FormControl("", Validators.maxLength(50)),

      option_5: new FormControl("", Validators.maxLength(50)),

      survey_type_id: new FormControl("", Validators.compose([
        Validators.required
      ])),

      survey_expired_time: new FormControl("", Validators.compose([
        Validators.required
      ])),

      survey_category_id: new FormControl("", Validators.compose([
        Validators.required
      ])),

      tags: new FormControl("", Validators.compose([
        // Validators.required
      ])),
    });
  }

  // Get group survey list
  getGroupSurveyList = function (pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr) {

    this.selected_group_id = $('#group_id').val() ? $('#group_id').val() : null;
    if(surveyStatus == null){
      surveyStatus = 0;
    }
    this.commonService.process();
    this.authService.getGroupSurveyList(pageNo, limit, surveyTypeId, categoryId, surveyStatus, searchStr, this.selected_group_id).subscribe(data => {
      if (data.success) {

        this.isSurveyAvailable = false;
        this.surveyList = data.survey;
        this.total = data.total;
        this.setPage(pageNo, true);
        this.pageNo = pageNo;
        this.redirectUrl = "pageNo=" + pageNo + "&categoryId=" + categoryId + "&surveyStatus=" + surveyStatus + "&searchStr=" + searchStr + "&surveyTypeId=123456";
        this.redirectUrlGroup = "pageNo=" + pageNo + "&categoryId=" + categoryId + "&surveyStatus=" + surveyStatus + "&searchStr=" + searchStr + "&surveyTypeId=123456&groupList=1"
      }
      else {
        this.surveyList = [];
        this.isSurveyAvailable = true;
      }
      this.commonService.hideProcess();
    });
  }

  // Pagination
  setPage(page: number, param) {
    //$('.pages').removeClass('active')
    $('.pages.active a').each(function () {
      if (parseInt($(this).text()) != page)
        $(this).parent('li').removeClass('active');
    });
    if ($('#first, #prev').hasClass('disabled') && page != this.pager.totalPages && page != 1)
      $('#first, #prev').removeClass('disabled');
    if ($('#next, #last').hasClass('disabled') && page != this.pager.totalPages)
      $('#next, #last').removeClass('disabled');

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    this.pager = this.pagerService.getPager(this.total, page);
    // get current page of items
    this.pagedItems = this.surveyList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    if (!param) {
      this.getGroupSurveyList(page, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
    }
  }

  // Delete selected Survey Details
  deleteSelectedSurvey = function (survey) {
            // debugger;;
    this.isDeleteSurvey = true;
    this.deleteSelectedSurveyData = survey
  }

  // Delete Survey
  deleteSurvey = function (id) {
            // debugger;;
    this.authService.deleteSurvey(id).subscribe(data => {
              // debugger;;
      if (data.success) {
        this.authService.cancelProcess();
        this.getGroupSurveyList(this.pageNo, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
        jQuery.growl.notice({ title: 'Success', message: data.message });
      }
      else {
        jQuery.growl.error({ title: 'Error', message: data.error });
      }
    });
  }

  // Update survey status .
  updateSurveyStatus = function (surveyId) {
    this.authService.updateSurveyStatus(surveyId).subscribe(data => {
      if (data.success) {
        jQuery.growl.notice({ title: 'Success', message: data.message });
      }
      else {
        $('#chk_' + surveyId).click();
        $('#chk_' + surveyId).is(':checked') ? $('#chk_' + surveyId).next('span.toggler').removeClass('off') : $('#chk_' + surveyId).next('span.toggler').addClass('off')
        jQuery.growl.error({ title: 'Error', message: data.error });
      }
    });
  }

  // Search survey
  searchSurvey = function () {
    this.searchStr = $("#search").val();
    this.surveyCategory = $("#surveyCategory").val();
    this.surveyStatus = $("#surveyStatus").val();
    this.getGroupSurveyList(1, this.limit, this.url, this.surveyCategory, this.surveyStatus, this.searchStr);
  }
}



// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/group-survey-list/group-survey-list.component.ts